import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import { useLogoutModal } from '@app/components/LogoutModal/hooks/useLogoutModal';
import type { NLogoutModal } from '@app/components/LogoutModal/LogoutModal.types';
import { CANCEL } from '@app/constants';

export const LogoutModal: NLogoutModal.Main = ({
  isModalOpen,
  setIsModalOpen,
}) => {
  const { handleOk, handleCancel } = useLogoutModal();

  return (
    <Modal
      okText={<span data-testid="save">Выйти</span>}
      cancelText={<span data-testid="cancel">{CANCEL}</span>}
      data-testid="logout-popup"
      title={<span data-testid="logout-title">Выход из аккаунта</span>}
      open={isModalOpen}
      onOk={() => handleOk(setIsModalOpen)}
      onCancel={() => handleCancel(setIsModalOpen)}
      closeIcon={<CloseOutlined data-testid="close-popup" />}
    >
      <p data-testid="description-logout">
        Вы действительно хотите выйти из аккаунта?
      </p>
    </Modal>
  );
};
